<template>
  <app-layout
    :state="state"
    header-type="landing"
  >
    <template #header>
      <div
        class="flex items-baseline"
        :class="{
          'pb-6': tabs.length > 1
        }"
      >
        <div class="flex-1">
          <div
            ref="switcher"
            class="mb-2 relative"
          >
            <button
              type="button"
              class="text-2xs border-2 font-bold rounded-sm flex items-center bg-white uppercase px-3 py-1 focus:outline-none"
              :class="{
                'border-primary-800': showWaves,
                'border-transparent': !showWaves,
              }"
              @click="showWaves = true"
            >
              Switch <small class="ml-2">&#x25BC;</small>
            </button>
            <div
              v-if="showWaves"
              class="absolute top-full left-0 bg-white text-black w-32 mt-1 rounded-sm shadow"
            >
              <a
                v-for="pot in fundingPots"
                :key="pot.id"
                :href="route('funding.competitions.index', pot.id)"
                class="border-b block px-3 py-2 text-black no-underline"
                :class="{
                  'text-black hover:bg-primary-50': pot.id !== state.funding_pot.id,
                  'bg-primary-50 text-primary-700': pot.id === state.funding_pot.id,
                }"
              >
                {{ pot.name }}
              </a>
            </div>
          </div>
          <h1 class="text-3xl md:text-4xl font-light">
            {{ state.funding_pot.name }}
          </h1>
          <p class="text-xl md:text-2xl font-semibold">
            {{ competitionType ? competitionType + "s" : "Administration Area" }}
          </p>
        </div>
        <div v-if="$slots.headerAction" class="flex-no-shrink ml-8 w-48">
          <slot name="headerAction"></slot>
        </div>
      </div>
    </template>
    <app-header>
      <template #navigation>
        <ul v-if="tabs">
          <li
            v-for="(tab, index) in tabs"
            :key="index"
          >
            <a
              v-if="tab.type != 'divider'"
              :href="route(tab.route, state.funding_pot.id)"
              :class="{
                'is-active': currentRoute === tab.route
              }"
            >
              {{ tab.name }}
            </a>
            <span v-else class="w-px mx-6 bg-grey-300 h-full block"></span>
          </li>
        </ul>
      </template>
    </app-header>
    <template #tertiary>
      <portal-target name="tertiary" slim />
    </template>
    <slot />
  </app-layout>
</template>

<script>
export default {
  name: "FundingBase",
  props: {
    currentFundingPotId: {
        type: Number,
        default: 25,
      }
  },
  data() {
    return {
      showWaves: false
    };
  },
  computed: {
    fundingPots() {
      return this.state.funding_pots;
    },
    currentRoute() {
      return this.state.route;
    },
    competitionType() {
      return this.state.competition?.type?.name ?? false;
    },
    tabs() {
      return [
        {
          name: "Overview",
          route: "funding.competitions.index",
          show: true,
        },
        {
          name: "Expression of Interest",
          route: "funding.eoi.index",
          show: this.currentFundingPotId < 26,
        },
        {
          name: "Applications",
          route: "funding.applications.index",
          show: true,
        },
        {
          name: "Assessments",
          route: "funding.assessments.index",
          show: true
        },
        {
          name: "Projects",
          route: "funding.projects.index",
          show: this.currentFundingPotId >= 26,
        },
        {
          type: "divider",
          show: this.currentFundingPotId >= 26,
        },
        {
          name: "Assessor Requests",
          route: "funding.assessor-requests.index",
          show: this.currentFundingPotId >= 26,
        },
        {
          name: "Delivery Partner Requests",
          route: "funding.delivery-partner-requests.index",
          show: this.currentFundingPotId >= 26,
        },
        // {
        //   name: "Claims",
        //   route: "funding.claims.index"
        // }
        // {
        //   name: 'Notifications',
        //   route: 'funding.notifications.index',
        // }
      ].filter(tab => tab.show);
    }
  },
  mounted() {
    document.addEventListener("click", clickOutside.bind(this));
  },
  destroyed() {
    document.removeEventListener("click", clickOutside.bind(this));
  }
};

function clickOutside(el) {
  if (!this.$refs.switcher.contains(el.target)) {
    this.showWaves = false;
  }
}
</script>
